module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-latin488.2280698.woff2";